import { call, put, select, takeLatest } from 'redux-saga/effects';
import * as Apis from '../../apis';
import * as Actions from './actions';
import { poListFilterAction } from '../../../list/actions';
import { getPoDetailsBucketTotalsSuccess, filterPoItems, filterConfirmedPoItems } from '../../actions';
import { IAppState } from '@/app-state';
import { poBuckets } from '@/app-constants';
import { getCodesFromDetailState } from '@/app/common/conversation/sagas';

export const getBucketCounts = (state: IAppState) => ({
  new: state.poDetailsBucketTotalsState.newTotal,
  revised: state.poDetailsBucketTotalsState.revisedTotal,
  buyerChangeRequest: state.poDetailsBucketTotalsState.buyerReviewTotal,
  confirmed: state.poDetailsBucketTotalsState.acceptedTotal
});

export function* poChangeRequest(action) {
  try {
    const codes = yield select(getCodesFromDetailState);
    const request = { ...action.payload, ...codes };
    yield call(Apis.createChangeRequest, request);
    yield put(Actions.poChangeRequestSuccess({
      purchaseOrderId: action.payload.purchaseOrderId,
      changeFrom: action.payload.stateId
    }));

    const { excludedPurchaseOrderItemIds, purchaseOrderItemIds, changeFrom } = action.payload;
    const excludedItemCount = excludedPurchaseOrderItemIds && excludedPurchaseOrderItemIds.length;
    const itemCount = purchaseOrderItemIds && purchaseOrderItemIds.length;

    if (excludedItemCount || itemCount) {
      const bucketCounts = yield select(getBucketCounts);

      if (changeFrom === poBuckets.new.state) {
        yield put(getPoDetailsBucketTotalsSuccess({
          newTotal: excludedItemCount || (bucketCounts.new - itemCount),
          buyerReviewTotal: bucketCounts.buyerChangeRequest + 1
        }));
        yield put(filterPoItems({
          excludedPurchaseOrderItemIds: request.excludedPurchaseOrderItemIds,
          purchaseOrderItemIds: request.purchaseOrderItemIds
        }));
      } else if(changeFrom === poBuckets.revised.state) {
        yield put(getPoDetailsBucketTotalsSuccess({
          revisedTotal: excludedItemCount || (bucketCounts.revised - itemCount),
          buyerReviewTotal: bucketCounts.buyerChangeRequest + 1
        }));
        yield put(filterPoItems({
          excludedPurchaseOrderItemIds: request.excludedPurchaseOrderItemIds,
          purchaseOrderItemIds: request.purchaseOrderItemIds
        }));
      } else {
        yield put(getPoDetailsBucketTotalsSuccess({
          acceptedTotal: excludedItemCount || (bucketCounts.confirmed - itemCount),
          buyerReviewTotal: bucketCounts.buyerChangeRequest + 1
        }));
        yield put(filterConfirmedPoItems({
          excludedPurchaseOrderItemIds: request.excludedPurchaseOrderItemIds,
          purchaseOrderItemIds: request.purchaseOrderItemIds
        }));
      }
    } else {
      yield put(poListFilterAction(action.payload.purchaseOrderId));
    }
  } catch (error) {
    yield put(Actions.poChangeRequestFailure(error));
  }
}

export function* watchPoCreateChangeRequestSaga() {
  yield takeLatest(Actions.PO_CHANGE_REQUEST.REQUEST, poChangeRequest);
}
